import DeleteConfirmation from './DeleteCofirmation';
export default DeleteConfirmation;
